export const rents = [
  { id: 1, title: 'краткосрочная аренда (менее 5 лет)', value: 0.73 },
  { id: 2, title: 'долгосрочная аренда (6-49 лет)', value: 0.83 },
  { id: 3, title: 'собственность', value: 1 },
];
